import { logger } from '../logger';
import { CommonUtils } from './commonUtils';

/**
 * This is the interface for logging as it logs to the following destinations :
 * 1) Browser Console
 * 2) katal(API Gateway -> CloudWatchLog)
 */
export class LogHelper {
    private static instance : LogHelper;

    private windowRequestId = CommonUtils.getRequestId();
    private parentWindowRequestId = CommonUtils.getParentRequestId();

    /**
     * @returns an instance of this class
     */
    public static getInstance(): LogHelper {
        if (!LogHelper.instance) {
            LogHelper.instance = new LogHelper();
        }
        return LogHelper.instance;
    }

    public info(infoMessage: string, context?: Record<string, any>) : Promise<void>{
        const infoWithTime = `Timestamp : ${new Date()} | ${this.windowRequestId} | ${infoMessage} `;
        const newContext = {
            ...context,
            parentRequestId: this.parentWindowRequestId
        };
        return logger.info(infoWithTime, newContext)
            .catch((err) => {
                this.handleLogFailure(err, infoWithTime);
            });
    }

    public error(errorMessage: string, error?: any, context?: Record<string, any>): Promise<void> {
        const errorWithTime = `Timestamp : ${new Date()} | ${this.windowRequestId} | ${errorMessage} `;
        const newContext = {
            ...context,
            parentRequestId: this.parentWindowRequestId
        };
        if (error) {
            if (!error.name) {
                // eslint-disable-next-line no-param-reassign
                error.name = 'Generic error';
            }
            return logger.error(errorWithTime, error, newContext)
                .catch((err) => {
                    this.handleLogFailure(err, errorWithTime);
                });
        } else {
            return logger.error(errorWithTime, newContext)
                .catch((err) => {
                    this.handleLogFailure(err, errorWithTime);
                });
        }
    }

    public debug(debugMessage: string, context?: Record<string, any>): Promise<void> {
        if (!CommonUtils.isProduction()) {
            const debugWithTime = `Timestamp : ${new Date()} | ${this.windowRequestId} | ${debugMessage} `;
            const newContext = {
                ...context,
                parentRequestId: this.parentWindowRequestId
            };
            return logger.debug(debugWithTime, newContext)
                .catch((err) => {
                    this.handleLogFailure(err, debugWithTime);
                });
        }
        return Promise.resolve();
    }

    public fatal(fatalMessage: string, error: Error, context?: Record<string, any>): Promise<void> {
        const fatalWithTime = `Timestamp : ${new Date()} | ${this.windowRequestId} | ${fatalMessage} `;
        const newContext = {
            ...context,
            parentRequestId: this.parentWindowRequestId
        };
        return logger.fatal(fatalWithTime, error, newContext)
            .catch((err) => {
                this.handleLogFailure(err, fatalWithTime);
            });
    }

    private handleLogFailure(err: Error, message : string) {
        const loggedError = `[Katal Log Failure] Timestamp : ${new Date()} | Failed to log following message : |
        ${message} due to following reason | ${err}`;
        console.error(loggedError);
    }

}
